import { restApi } from '../../services/api';
import { GetDropboxFoldersOutput } from './dropbox.repository.types';

export const dropboxRepository = () => ({
  validateCode: (dropboxOAuthCode: string) =>
    restApi.post(`/brands/general-settings/dropbox`, { dropboxOAuthCode }),
  getFolders: () =>
    restApi.get<GetDropboxFoldersOutput>(`/brands/general-settings/dropbox-folders`),
  removeConfig: () => restApi.delete(`/brands/general-settings/dropbox`),
  updateFolder: (dropboxFolder: string) =>
    restApi.patch(`/brands/general-settings`, { dropboxFolder }),
  updateFileSplitter: (fileCodesSeparator: string) =>
    restApi.patch(`/brands/general-settings`, { fileCodesSeparator }),
});
